:host {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    pointer-events: none;
    margin: 0;
}

:host(.hidden) {
    display: none;
}

:where(.inner) {
    background-color: var(--color-background);
    box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.11);
    overflow: auto;
    pointer-events: all;
}

:where(.arrow) {
    position: absolute;
    display: block;
    height: 24px;
    width: 24px;
    overflow: hidden;
    pointer-events: none;
}

:where(.arrow)::after {
        content: '';
        display: block;
        height: 24px;
        width: 24px;
        position: absolute;
        background-color: var(--color-secondary);
        border-radius: 50%;
        transition:
            opacity 400ms ease, transform 400ms ease;
        opacity: 0;
        transform: translateY(0px);
    }

[data-placement^='top']:where(.arrow) {
        top: 100%;
    }

[data-placement^='top']:where(.arrow)::after {
            bottom: 100%;
        }

.entered[data-placement^='top']:where(.arrow)::after {
            opacity: 1;
            transform: translateY(9px);
        }

[data-placement^='bottom']:where(.arrow) {
        bottom: 100%;
    }

[data-placement^='bottom']:where(.arrow)::after {
            top: 100%;
        }

.entered[data-placement^='bottom']:where(.arrow)::after {
            opacity: 1;
            transform: translateY(-9px);
        }

[data-placement^='left']:where(.arrow) {
        left: 100%;
    }

[data-placement^='left']:where(.arrow)::after {
            right: 100%;
        }

.entered[data-placement^='left']:where(.arrow)::after {
            opacity: 1;
            transform: translateX(9px);
        }

[data-placement^='right']:where(.arrow) {
        right: 100%;
    }

[data-placement^='right']:where(.arrow)::after {
            left: 100%;
        }

.entered[data-placement^='right']:where(.arrow)::after {
            opacity: 1;
            transform: translateX(-9px);
        }

:where(es-popper-x),
:where(es-popper-y) {
    display: block;
    pointer-events: none;
}
